import common from './common';

const offersRoute = () => {
    const culture = common.getLang();
    const offers = {
        'it-IT': 'offerte',
        'es-ES': 'ofertas',
        'fr-FR': 'promotions',
        'en-GB': 'offers',
        'en-US': 'sales',
        'en-AU': 'offers-1',
        'de-DE': 'sale',
    };
    return `${common.getSiteUrl()}/${offers[culture]}`;
};

const latestArrivalsRoute = () => {
    const culture = common.getLang();
    const latestArrivals = {
        'it-IT': 'ultimi-arrivi',
        'es-ES': 'ultimas-novedades',
        'fr-FR': 'derniers-arrivages',
        'en-GB': 'latest-arrivals',
        'en-US': 'new-products',
        'en-AU': 'latest-arrivals-1',
        'de-DE': 'neuheiten',
    };
    return `${common.getSiteUrl()}/${latestArrivals[culture]}`;
};
export { offersRoute, latestArrivalsRoute };
